import React from 'react'

export default function Gradient(props) {
  return (
    <div className='z-0 fixed' style={{left : props.left, top : props.top, background : props.color, filter : `blur(${props.blur}px)`, width : `${props.size}px` , height : `${props.size}px`, transform : "translateX(-50%)"}}>
    </div>
  )
}
